import styled from "styled-components";

export const DontMissCarouselGridWrapper = styled.div<{ $removePaddingUsedAsMargin?: boolean }>`
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    padding: ${(props) => (props.$removePaddingUsedAsMargin ? 0 : props.theme.spacing(5, 0, 5))};
  }
`;
